import type { Control, FieldValues, Path } from 'react-hook-form'
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '~/shadcn/ui/select'
import { FormField, FormItem } from '~/shadcn/ui/form/form'
import { FieldContent, FieldError, FieldLabel } from '~/shadcn/ui/field'
import { RequiredLabel } from '~/@mid_ui-form/required-label/RequiredLabel'
import { useCountries } from '~/@mid_settings/countries/useCountries'

export function CountrySelect<T extends FieldValues>(props: {
  control: Control<T>
}) {
  const { data: countries } = useCountries()
  const countryOptions =
    countries
      ?.filter((country) => ['SK', 'CS'].includes(country._id))
      .map((country) => ({
        value: country._id,
        label: country.native,
      })) ?? []
  return (
    <FormField
      control={props.control}
      name={'country' as Path<T>}
      rules={{ required: 'Toto pole je povinné.' }}
      render={({ field, fieldState }) => (
        <FormItem>
          <FieldLabel>
            <RequiredLabel text="Krajina" />
          </FieldLabel>
          <FieldContent>
            <Select value={field.value} onValueChange={field.onChange}>
              <SelectTrigger
                aria-invalid={!!fieldState.error}
                className="w-full">
                <SelectValue placeholder="Vyberte krajinu" />
              </SelectTrigger>
              <SelectContent className="bg-[#fff] ">
                <SelectGroup>
                  {countryOptions.map((option) => (
                    <SelectItem key={option.value} value={option.value}>
                      {option.label}
                    </SelectItem>
                  ))}
                </SelectGroup>
              </SelectContent>
            </Select>
            {fieldState.error && (
              <FieldError className="text-sm text-destructive">
                {fieldState.error?.message}
              </FieldError>
            )}
          </FieldContent>
        </FormItem>
      )}
    />
  )
}
